import { useSyncedStore } from '../store/synced';

// Read-only selector for the family-wide sound toggle. Defaults to false
// when the tree hasn't hydrated yet — better to skip a tone than to startle
// a kid by playing once they hydrate.
export function useSoundEnabled(): boolean {
  return useSyncedStore((s) => s.tree?.settings.soundOn ?? false);
}
